<template>
  <div class="panel panel-default">
    <!-- Default panel contents -->
    <div class="panel-heading">{{ titulo }}</div>

    <!-- Table -->
    <table class="table table-striped table-hover table-condensed table-responsive">
      <thead>
        <tr>
          <th class="text-center">Dorsal</th>
          <th class="text-left">Nome</th>
          <th class="text-center">Equipa</th>
          <th class="text-center">Escalão</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="participante in lista">
          <td class="text-center">{{ participante.dorsal }}</td>
          <td class="text-left">{{ participante.nome }}</td>
          <td class="text-center">{{ participante.equipa }}</td>
          <td class="text-center">{{ participante.escalao }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TabelaValidados',
  props: [
    'lista',
    'titulo'
  ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// TabelaValidados.vue?6e09771c